export const groupManagementRoutes = [
  {
    path: "/group-management",
    name: "groupManagement",
    component: () =>
      import("@shared/userManagement/groupManagement/GroupManagement.vue"),
    meta: {
      appClientId: "smx-user-mgmt",
      breadcrumbs: [
        {
          label: "groupManagement",
          route: { name: "groupManagement" },
        },
      ],
    },
  },
  {
    path: "/group-management/:id",
    name: "groupManagementDetail",
    props: true,
    component: () =>
      import("@shared/userManagement/groupManagement/GroupDetail.vue"),
    meta: {
      appClientId: "smx-user-mgmt",
      breadcrumbs: [
        {
          label: "groupManagement",
          route: { name: "groupManagement" },
        },
      ],
    },
  },
];
